import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FileCardButton from "../../../../../UI/FileCardButton/FileCardButton";
import Warning from "../../../../../common/Warning/Warning";
import StaticAnalysisIcon from "../../../../../Icon-SVG/StaticAnalysisIcon";

import { addNotification } from "../../../../../../store/actions/notifierActions";
import { RequestStaticSubmit } from "../../../../../../store/actions/dashboardActions";

const StaticSubmit = ({ selectedFiles, setSelectedFiles }) => {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const licenceCheck = useSelector((state) => state?.users?.licenceCheck || {});

  const staticClickHandler = () => {
    if (licenceCheck.licenceStatus === "Unavailable") {
      dispatch(
        addNotification({
          message: "Your license key has expired. Please contact CyberFortress Technology Team.",
          options: { variant: "error" },
        }),
      );
    } else if (selectedFiles.length === 0) {
      setError("Please select at least one file");
      setShow(true);
    } else {
      const staticSubmitFiles = selectedFiles.map((data) => ({
        file: data.file,
      }));
      dispatch(RequestStaticSubmit(staticSubmitFiles));
      setSelectedFiles([]);
    }
  };

  return (
    <FileCardButton onClick={staticClickHandler}>
      <StaticAnalysisIcon width={22} height={22} />
      <p>Static</p>
      <Warning
        onClickOk={() => setShow(false)}
        show={show}
        setShow={setShow}
        text={error}
        article="Warning"
        cancelDisable={true}
        textOK="Okay"
      />
    </FileCardButton>
  );
};

export default StaticSubmit;
